import { useState } from "react";

export function Field({ label, id, required, children, hint }) {
  return (
    <div>
      <label htmlFor={id} className="mb-1.5 block text-sm font-semibold text-navy">
        {label} {required && <span className="text-victory" aria-hidden="true">*</span>}
      </label>
      {children}
      {hint && <p className="mt-1 text-xs text-slate-500">{hint}</p>}
    </div>
  );
}

export const HEAR_OPTIONS = [
  "Google search",
  "Social media",
  "Friend or family",
  "Invitation or yard sign",
  "Drove by the building",
  "Other",
];

export const inputCls =
  "w-full rounded-xl border border-slate-300 bg-white px-4 py-3 text-base text-ink placeholder:text-slate-400 focus:border-navy focus:outline-none focus:ring-2 focus:ring-navy/15 transition-colors";

export function TextInput({ id, testId, ...props }) {
  return <input id={id} data-testid={testId || id} className={inputCls} {...props} />;
}

export function TextArea({ id, testId, rows = 4, ...props }) {
  return <textarea id={id} rows={rows} data-testid={testId || id} className={inputCls} {...props} />;
}

export function SubmitButton({ children, testId, loading }) {
  const [hover, setHover] = useState(false);
  return (
    <button
      type="submit"
      data-testid={testId}
      disabled={loading}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      className="group relative inline-flex w-full items-center justify-center gap-2 overflow-hidden rounded-full bg-victory px-8 py-4 font-display text-base font-700 tracking-wide text-white shadow-lift transition-transform duration-300 hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-victory focus-visible:ring-offset-2 disabled:opacity-60 sm:w-auto"
    >
      <span className={`absolute inset-0 bg-victory-dark transition-transform duration-300 ${hover ? "translate-y-0" : "translate-y-full"}`} aria-hidden="true" />
      <span className="relative">{loading ? "SENDING..." : children}</span>
    </button>
  );
}
